import React from 'react';
import {
  Box,
  Typography,
  Card,
  CardContent,
  Switch,
  FormControlLabel,
  Divider,
} from '@mui/material';
import { Notifications as NotificationsIcon } from '@mui/icons-material';
import { colors, fonts, spacing, borderRadius, shadows } from '../../constants';
import SectionHeader from './SectionHeader';

/**
 * NotificationSection Component
 * Notification Preferences card component
 */
const NotificationSection = ({
  notificationSettings,
  isSavingEmailNotification,
  isLoadingPreferences,
  onNotificationToggle,
}) => {
  return (
    <Card
      sx={{
        mb: spacing.md,
        boxShadow: shadows.md,
        borderRadius: borderRadius.card,
        border: `1px solid ${colors.borderDefault}`,
      }}
    >
      <CardContent sx={{ p: spacing.md }}>
        <SectionHeader
          icon={NotificationsIcon}
          title="Notification Preferences"
        />

        <Box sx={{ mb: spacing.md }}>
          <Typography
            sx={{
              fontWeight: fonts.weightSemiBold,
              fontSize: fonts.fontSizeMd,
              color: colors.textPrimaryDark,
              mb: spacing.sm,
            }}
          >
            Notification Channels
          </Typography>
          <Divider sx={{ mb: spacing.sm }} />
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: spacing.sm }}>
            <FormControlLabel
              control={
                <Switch
                  checked={notificationSettings.emailNotifications}
                  onChange={() => onNotificationToggle('emailNotifications')}
                  disabled={isSavingEmailNotification || isLoadingPreferences}
                  sx={{
                    '& .MuiSwitch-root': {
                      width: 58,
                      height: 38,
                    },
                    '& .MuiSwitch-switchBase': {
                      padding: 1,
                      '&.Mui-checked': {
                        transform: 'translateX(20px)',
                        color: '#FFFFFF',
                        '& + .MuiSwitch-track': {
                          backgroundColor: colors.primary,
                          background: colors.primaryGradient,
                          opacity: 1,
                          border: 'none',
                        },
                      },
                      '&.Mui-disabled': {
                        '& + .MuiSwitch-track': {
                          opacity: 0.5,
                        },
                      },
                    },
                    '& .MuiSwitch-thumb': {
                      width: 22,
                      height: 22,
                      boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)',
                    },
                    '& .MuiSwitch-track': {
                      borderRadius: 19,
                      backgroundColor: '#D1D5DB',
                      opacity: 1,
                      border: '1px solid #9CA3AF',
                      transition: 'background-color 0.2s, border-color 0.2s',
                    },
                  }}
                />
              }
              label={
                <Box>
                  <Typography sx={{ fontWeight: fonts.weightMedium, fontSize: fonts.fontSizeSm, color: colors.textPrimaryDark }}>
                    Email Notifications
                  </Typography>
                  <Typography sx={{ fontSize: fonts.fontSizeXs, color: colors.textSecondary }}>
                    Receive notifications via email
                    {isSavingEmailNotification && ' (Saving...)'}
                  </Typography>
                </Box>
              }
            />
            {/* <FormControlLabel
              control={
                <Switch
                  checked={notificationSettings.whatsappNotifications}
                  onChange={() => onNotificationToggle('whatsappNotifications')}
                  sx={{
                    '& .MuiSwitch-switchBase.Mui-checked': {
                      color: colors.primary,
                    },
                    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                      background: colors.primaryGradient,
                    },
                  }}
                />
              }
              label={
                <Box>
                  <Typography sx={{ fontWeight: fonts.weightMedium, fontSize: fonts.fontSizeSm, color: colors.textPrimaryDark }}>
                    WhatsApp Notifications
                  </Typography>
                  <Typography sx={{ fontSize: fonts.fontSizeXs, color: colors.textSecondary }}>
                    Receive notifications via WhatsApp
                  </Typography>
                </Box>
              }
            /> */}
            {/* <FormControlLabel
              control={
                <Switch
                  checked={notificationSettings.inAppNotifications}
                  onChange={() => onNotificationToggle('inAppNotifications')}
                  sx={{
                    '& .MuiSwitch-switchBase.Mui-checked': {
                      color: colors.primary,
                    },
                    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                      background: colors.primaryGradient,
                    },
                  }}
                />
              }
              label={
                <Box>
                  <Typography sx={{ fontWeight: fonts.weightMedium, fontSize: fonts.fontSizeSm, color: colors.textPrimaryDark }}>
                    In-App Notifications
                  </Typography>
                  <Typography sx={{ fontSize: fonts.fontSizeXs, color: colors.textSecondary }}>
                    Receive notifications within the application
                  </Typography>
                </Box>
              }
            /> */}
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
};

export default NotificationSection;
